module.exports = __webpack_public_path__ + "img/icon-ny-6.a9221281.svg";